import ProductDetailAttributesView from './product-detail-attributes-view'

export default ProductDetailAttributesView
